import React from 'react';

interface DocsPageSkeletonProps {
  isRtl?: boolean;
}

export const DocsPageSkeleton: React.FC<DocsPageSkeletonProps> = ({ isRtl = false }) => {
  return (
    <div className="w-full animate-pulse py-8 space-y-12" dir={isRtl ? 'rtl' : 'ltr'}>
      {/* Header Skeleton */}
      <div className="space-y-4">
        <div className="h-6 w-36 rounded-full bg-white/[0.04] border border-white/[0.05]" />
        <div className="h-10 w-3/4 max-w-lg rounded-xl bg-white/[0.05]" />
        <div className="h-4 w-full max-w-2xl rounded-lg bg-white/[0.03]" />
        <div className="h-4 w-2/3 max-w-xl rounded-lg bg-white/[0.02]" />
      </div>

      {/* Primary Section Skeleton */}
      <div className="rounded-2xl border border-white/[0.05] bg-white/[0.02] p-8 md:p-10 space-y-6">
        <div className="flex items-center gap-3">
          <div className="h-10 w-10 rounded-xl bg-white/[0.05]" />
          <div className="h-6 w-48 rounded-lg bg-white/[0.04]" />
        </div>
        <div className="space-y-3">
          <div className="h-4 w-full rounded bg-white/[0.03]" />
          <div className="h-4 w-5/6 rounded bg-white/[0.02]" />
          <div className="h-4 w-4/6 rounded bg-white/[0.02]" />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 pt-4">
          <div className="h-28 rounded-xl bg-white/[0.02] border border-white/[0.03]" />
          <div className="h-28 rounded-xl bg-white/[0.02] border border-white/[0.03]" />
          <div className="h-28 rounded-xl bg-white/[0.02] border border-white/[0.03]" />
        </div>
      </div>

      {/* Secondary Section Skeleton */}
      <div className="rounded-2xl border border-white/[0.05] bg-white/[0.02] p-8 md:p-10 space-y-4">
        <div className="h-6 w-40 rounded-lg bg-white/[0.04]" />
        <div className="space-y-3 pt-2">
          <div className="h-14 rounded-xl bg-white/[0.02] border border-white/[0.03]" />
          <div className="h-14 rounded-xl bg-white/[0.02] border border-white/[0.03]" />
          <div className="h-14 rounded-xl bg-white/[0.02] border border-white/[0.03]" />
        </div>
      </div>
    </div>
  );
};

export default DocsPageSkeleton;
